/* CREATE FLOW renderer — CustoMeow-template edition (2026-09-30 v2)
   卡片预览 = CustoMeow 定制窗口同款效果：
   直接读取 CustoMeow 公开配置 json.staticmeow.com/.../{sku}.json，
   按其 knifes[0].children 图层顺序在 canvas 复刻：
   底图 → (mask=-1 遮罩 + module.key=='value' 照片层) → 装饰图 → 文字层（原字体 TTF/OTF）。
   CustoMeow 配置与定制模块一律只读，主题不改其任何数据。 */
(() => {
  const CONF = 'https://json.staticmeow.com/customeow/app/shopify/57382863040/';
  const BASE = 'https://assets.staticmeow.com/customeow';
  const SKU = {
    blanket: 'CS-BLK-0001-GRANDMA',
    'ornament-close': 'CS-ORN-0014-CLOSE',
    'ornament-passed': 'CS-ORN-0006-PASSED',
    acrylic: 'CS-LOVEMOM-ACRYLIC',
    'ornament-dad': 'CS-ORN-0001-DAD',
    slate: 'CS-SLT-0001-STILLYOU',
    light: 'CS-LGT-0004-PATHS'
  };
  // 照片窗静态回落（close_up 聚焦 / fitRegion），正常路径以配置实时值为准
  const ZONE = {
    blanket: { x: .335, y: .21, w: .49, h: .49 },
    'ornament-close': { x: .111, y: .076, w: .757, h: .761 },
    'ornament-passed': { x: 0, y: 0, w: 1, h: 1 },
    acrylic: { x: .313, y: .443, w: .385, h: .373 },
    'ornament-dad': { x: .216, y: .118, w: .575, h: .565 },
    slate: { x: 0, y: 0, w: 1, h: 1 },
    light: { x: .175, y: .102, w: .664, h: .389 }
  };
  const cache = new Map(), confCache = new Map(), fontCache = new Map();
  function image(url) {
    if (!cache.has(url)) cache.set(url, new Promise((resolve, reject) => {
      const i = new Image(); i.crossOrigin = 'anonymous';
      i.onload = () => resolve(i);
      i.onerror = () => { cache.delete(url); reject(Error('Image unavailable')); };
      i.src = url;
    }));
    return cache.get(url);
  }
  function getConfig(pid) {
    const sku = SKU[pid];
    if (!sku) return Promise.reject(Error('No CustoMeow sku for ' + pid));
    if (!confCache.has(sku)) confCache.set(sku, fetch(CONF + sku + '.json').then(r => {
      if (!r.ok) throw Error('config ' + r.status);
      return r.json();
    }).catch(e => { confCache.delete(sku); throw e; }));
    return confCache.get(sku);
  }
  async function ensureFont(fam) {
    if (!fam || !fam.url) return null;
    const name = fam.title || ('cm-' + fam.id);
    if (!fontCache.has(name)) fontCache.set(name, (async () => {
      try {
        const f = new FontFace(name, `url("${BASE + fam.url}")`);
        await f.load(); document.fonts.add(f); return name;
      } catch { return null; }
    })());
    return fontCache.get(name);
  }
  const rgba = c => `rgba(${c?.r || 0},${c?.g || 0},${c?.b || 0},${c?.a == null ? 1 : c.a})`;
  const rect = (ch, W, H) => { const cx = W / 2 + (+ch.left || 0), cy = H / 2 + (+ch.top || 0); return { x: cx - ch.width / 2, y: cy - ch.height / 2, w: ch.width, h: ch.height }; };
  // Neutral product-only illustrations are used only when a discovery preview fails.
  function fallback(pid) {
    const forms = {
      blanket: '<path d="M140 120 435 80 490 320 190 380Z" fill="#e4ded3"/><path d="m158 142 265-36 43 197-267 57Z" fill="#f6f2ea"/>',
      'ornament-close': '<ellipse cx="300" cy="254" rx="116" ry="124" fill="#eee8dc" stroke="#c9bda9" stroke-width="6"/><path d="M278 149Q240 39 289 46q60 0 32 101" fill="none" stroke="#c5ac88" stroke-width="14"/>',
      'ornament-passed': '<ellipse cx="300" cy="254" rx="116" ry="124" fill="#eee8dc" stroke="#c9bda9" stroke-width="6"/><path d="M278 149Q240 39 289 46q60 0 32 101" fill="none" stroke="#c5ac88" stroke-width="14"/>',
      'ornament-dad': '<ellipse cx="300" cy="254" rx="116" ry="124" fill="#eee8dc" stroke="#c9bda9" stroke-width="6"/><path d="M278 149Q240 39 289 46q60 0 32 101" fill="none" stroke="#c5ac88" stroke-width="14"/>',
      acrylic: '<rect x="110" y="90" width="380" height="285" fill="#c7ae8b"/><rect x="136" y="116" width="328" height="233" fill="#faf8f4"/>',
      slate: '<path d="m135 112 318-36 24 268-346 34Z" fill="#5c5c59"/><path d="m155 132 280-32 19 224-303 32Z"/>',
      light: '<rect x="155" y="75" width="290" height="270" fill="#f3ede1" stroke="#d1bea0" stroke-width="5"/><rect x="140" y="340" width="320" height="45" fill="#bda17c"/>'
    };
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="600" height="500" viewBox="0 0 600 500"><rect width="600" height="500" fill="#eeeae4"/><g fill="#e9e4da">${forms[pid] || forms.blanket}</g></svg>`);
  }
  function photoCrop(img, aspect, crop) {
    const c = document.createElement('canvas'); c.width = 1000; c.height = Math.round(1000 / aspect);
    const ctx = c.getContext('2d');
    const z = Math.max(c.width / img.width, c.height / img.height) * (crop?.zoom || 1), w = img.width * z, h = img.height * z;
    const x = (c.width - w) / 2 + (crop?.x || 0) * (w - c.width) / 2, y = (c.height - h) / 2 + (crop?.y || 0) * (h - c.height) / 2;
    ctx.drawImage(img, x, y, w, h); return c;
  }
  // Source preparation never uses a SKU ratio; quarter turns preserve the whole rotated canvas.
  async function prepare(photo, transform) {
    const img = await image(photo.originalUrl), t = window.CustomsoloCreate.sourceTransform(transform), swap = t.rotation % 180 !== 0;
    const W = swap ? img.height : img.width, H = swap ? img.width : img.height, scale = Math.min(1, 2048 / Math.max(W, H));
    const rotated = document.createElement('canvas'); rotated.width = Math.round(W * scale); rotated.height = Math.round(H * scale);
    const ctx = rotated.getContext('2d'); ctx.translate(rotated.width / 2, rotated.height / 2); ctx.rotate(t.rotation * Math.PI / 180);
    ctx.drawImage(img, -img.width * scale / 2, -img.height * scale / 2, img.width * scale, img.height * scale);
    const c = document.createElement('canvas'); c.width = rotated.width; c.height = rotated.height; const z = t.zoom;
    c.getContext('2d').drawImage(rotated, (c.width - c.width * z) / 2 + t.x * c.width * (z - 1) / 2, (c.height - c.height * z) / 2 + t.y * c.height * (z - 1) / 2, c.width * z, c.height * z);
    return { url: c.toDataURL('image/jpeg', .94), width: Math.round(W / z), height: Math.round(H / z) };
  }
  function fitRegion(pid) { const z = ZONE[pid] || ZONE.blanket; return { x: z.x, y: z.y, width: z.w, height: z.h }; }
  // 把单个图层（含可选 mask 对）合成到主 canvas
  async function paintLayer(ctx, ch, maskCh, drawContent, W, H) {
    const r = rect(ch, W, H);
    if (!maskCh) { ctx.save(); if (ch.opacity != null) ctx.globalAlpha = ch.opacity; await drawContent(ctx, r); ctx.restore(); return; }
    const off = document.createElement('canvas'); off.width = W; off.height = H;
    const o = off.getContext('2d');
    if (ch.opacity != null) o.globalAlpha = ch.opacity;
    await drawContent(o, r);
    o.globalAlpha = 1; o.globalCompositeOperation = 'destination-in';
    const maskImg = await image(BASE + maskCh.image);
    const mr = rect(maskCh, W, H);
    o.drawImage(maskImg, mr.x, mr.y, mr.w, mr.h);
    ctx.drawImage(off, 0, 0);
  }
  // 找某图层之后第一个带透明窗的全幅 overlay，返回其透明区 bbox（canvas 坐标）
  async function overlayWindow(children, fromIdx, W, H) {
    for (let i = fromIdx + 1; i < children.length; i++) {
      const ch = children[i];
      if (ch.type !== 'template:image:v2' || !ch.image || ch.mask === -1) continue;
      if (ch.width < W * .9 || ch.height < H * .9) continue;
      const img = await image(BASE + ch.image);
      const off = document.createElement('canvas'); off.width = W; off.height = H;
      const o = off.getContext('2d'); const r = rect(ch, W, H);
      o.drawImage(img, r.x, r.y, r.w, r.h);
      const d = o.getImageData(0, 0, W, H).data;
      let minx = W, miny = H, maxx = -1, maxy = -1, n = 0;
      for (let y = 0; y < H; y += 3) for (let x = 0; x < W; x += 3) {
        if (d[(y * W + x) * 4 + 3] < 20) {
          n++;
          if (x < minx) minx = x; if (x > maxx) maxx = x;
          if (y < miny) miny = y; if (y > maxy) maxy = y;
        }
      }
      if (!n) continue;
      const area = (maxx - minx) * (maxy - miny);
      // 透明区太小（噪点）或接近全幅（不是窗口）都不算
      if (area < W * H * .05 || area > W * H * .7) continue;
      return { x: minx, y: miny, w: maxx - minx, h: maxy - miny };
    }
    return null;
  }
  async function composite(s, pid, override) {
    const M = window.CustomsoloCreate;
    const conf = await getConfig(pid);
    const knife = conf.knifes[0], W = knife.width, H = knife.height;
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const ctx = c.getContext('2d');
    let photoImg = null;
    if (s.assets.photo) photoImg = await image(s.assets.preparedPhoto?.url || s.assets.photo.originalUrl);
    const ps = s.productStates[pid];
    let pendingMask = null;
    for (let ci = 0; ci < knife.children.length; ci++) {
      const ch = knife.children[ci];
      if (ch.visible === false || ch.opacity === 0) { if (ch.mask === -1) pendingMask = null; continue; }
      if (ch.mask === -1) { pendingMask = ch; continue; }
      const type = ch.type || '';
      if (type === 'template:image:v2' && ch.module && ch.module.key === 'value' && photoImg) {
        // 用户照片层：cover-fit 进照片窗，应用 ps.crop
        const crop = override || ps?.crop || M.crop();
        let target = null;
        if (!pendingMask) {
          // 无遮罩且上方有全幅 overlay 透明窗（如心形夜灯）：照片填进透明窗
          target = await overlayWindow(knife.children, ci, W, H);
        }
        await paintLayer(ctx, ch, pendingMask, (o, r) => {
          const box = target || r;
          const cropped = photoCrop(photoImg, box.w / box.h, crop);
          o.drawImage(cropped, box.x, box.y, box.w, box.h);
        }, W, H);
      } else if (type === 'template:image:v2' && ch.image) {
        const img = await image(BASE + ch.image);
        await paintLayer(ctx, ch, pendingMask, (o, r) => o.drawImage(img, r.x, r.y, r.w, r.h), W, H);
      } else if (type === 'template:text:v2' && ch.text) {
        const fam = await ensureFont(ch.fontFamily);
        ctx.save();
        if (ch.opacity != null) ctx.globalAlpha = ch.opacity;
        ctx.fillStyle = rgba(ch.fill);
        const weight = ch.fontBold ? 'bold ' : '', style = ch.fontItalic ? 'italic ' : '';
        ctx.font = `${style}${weight}${ch.fontSize}px ${fam ? `"${fam}",` : ''}serif`;
        ctx.textAlign = ch.align || 'center'; ctx.textBaseline = 'middle';
        const cx = W / 2 + (+ch.left || 0), cy = H / 2 + (+ch.top || 0);
        String(ch.text).split('\n').forEach((line, i, arr) => {
          const lh = ch.fontSize * (ch.lineHeight || 1.4);
          ctx.fillText(line, cx, cy + (i - (arr.length - 1) / 2) * lh);
        });
        ctx.restore();
      }
      pendingMask = null;
    }
    return c;
  }
  async function render(s, pid, mode = 'current', override) {
    if (mode === 'video') throw Error('Unsupported media view');
    const c = await composite(s, pid, mode === 'current' ? override : undefined);
    if (mode === 'current' || mode === 'discovery' || mode === 'in_room' || mode === 'full_view') return c.toDataURL('image/jpeg', .9);
    if (mode === 'catalog') {
      const tile = document.createElement('canvas'); tile.width = 900; tile.height = 750; const t = tile.getContext('2d');
      t.fillStyle = '#e8e2da'; t.fillRect(0, 0, 900, 750); t.drawImage(c, 0, -25, 900, 900);
      return tile.toDataURL('image/jpeg', .9);
    }
    if (mode === 'close_up') {
      const z = ZONE[pid] || ZONE.blanket, S = 1000;
      const cx = (z.x + z.w / 2) * S, cy = (z.y + z.h / 2) * S;
      const out = document.createElement('canvas'); out.width = 1000; out.height = 650; const o = out.getContext('2d');
      const w = S * .6, h = w * 650 / 1000;
      o.drawImage(c, Math.max(0, Math.min(S - w, cx - w / 2)), Math.max(0, Math.min(S - h, cy - h / 2)), w, h, 0, 0, 1000, 650);
      return out.toDataURL('image/jpeg', .88);
    }
    throw Error('Unsupported media view');
  }
  window.CreateRenderer = { render, image, photoCrop, prepare, fitRegion, fallback };
})();
